<template>
  <div class="w-full text-white bg-black">
    <!-- Hero com fade -->
    <section
      class="relative h-[80vh] bg-cover bg-center"
      :class="[`bg-[url(${fileUrl}${mainEvent?.event?.banner})]`]"
    >
      <!-- Overlay escuro com gradiente -->
      <div
        class="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent"
      ></div>

      <div
        class="relative z-10 h-full flex flex-col justify-center items-start md:mt-10 px-8 md:px-24"
      >
        <JumbotronHome
          :title="'próximo evento da number one'"
          :subTitle="formatDateFull(mainEvent?.event?.starts_at)"
        >
          <template #tag>
            <p
              class="font-ufc-force text-[#D20A0A] text-xl md:text-2xl italic uppercase font-bold w-full mt-8 -mb-3"
            >
              {{ mainEvent?.event?.tag }}
            </p>
          </template>

          <template #principal>
            <div class="font-berthold-force italic font-bold text-white">
              <h2
                class="text-5xl md:text-7xl font-extrabold my-4 tracking-widest"
              >
                {{ mainEvent?.event?.title }}
              </h2>
            </div>
          </template>

          <template #descript>
            <div
              class="font-extralight text-white my-3 tracking-wide text-2xl font-berthold-force w-full md:w-1/2"
            >
              {{ mainEvent?.event?.description }}
            </div>
          </template>

          <template #button>
            <div
              class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 cursor-pointer pt-10 md:pt-2"
            >
              <a
                class="cursor-pointer inline-flex justify-center items-center py-2 px-10 text-base font-bold tracking-wide text-white bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300"
                @click="watchEvent(mainEvent?.event)"
              >
                <label
                  class="pb-3 mt-2 text-3xl uppercase font-berthold-force font-bold tracking-wide cursor-pointer flex"
                >
                  ASSISTA AO AVENTO
                  <PhTicket class="w-8 h-8 ml-3 -rotate-45" />
                </label>
              </a>

            </div>
          </template>
        </JumbotronHome>
      </div>
    </section>

    <!-- Carrossel de eventos -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        PRÓXIMOS EVENTOS
      </h2>

      <Carrossel>
        <CardEventoPreview
          v-for="(item, index) in lastEvents"
          :key="index"
          :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
          :title="item.title"
          :date="formatDate(item.date)"
          :live="item.is_live"
          @click="watchEvent(item)"
        />
      </Carrossel>
    </section>

    <!-- OUTROS EVENTOS AO VIVO -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        OUTROS EVENTOS AO VIVO
      </h2>

      <Carrossel>
        <CardEventoPreview
          v-for="(item, index) in shuffleArray(lastEvents)"
          :key="index"
          :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
          :title="item.title"
          :date="formatDate(item.date)"
          :live="item.is_live"
          @click="watchEvent(item)"
        />
      </Carrossel>
    </section>

    <!-- ULTIMOS EVENTOS -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        ULTIMOS EVENTOS
      </h2>

      <Carrossel>
        <CardEventoPreview
          v-for="(item, index) in shuffleArray(lastEvents)"
          :key="index"
          :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
          :title="item.title"
          :date="formatDate(item.date)"
          :live="item.is_live"
          @click="watchEvent(item)"
        />
      </Carrossel>
    </section>
  </div>
</template>

<script setup>
import { onBeforeMount, computed } from 'vue'

import { dataShared } from '@/shared/store'
import CardEventoPreview from '../auth/components/CardEventoPreview.vue'
import JumbotronHome from '@/shared/components/__partials/JumbotronHome.vue'
import { PhTicket } from '@phosphor-icons/vue'
import router from '@/router'
import SharedService from '@/shared/services/shared'
import { formatDate } from '@/utils/formaters'
import moment from 'moment'
import 'moment/locale/pt-br'
import { showToast as toast } from '@/helpers/UseToasts'
import Carrossel from '../auth/components/_partials/Carrossel.vue'

const banner = require('@/assets/logo/icon.png')
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const mainEvent = computed(() => dataShared.getters.getMainEvent)
const lastEvents = computed(() => dataShared.getters.getEvents)

async function watchEvent (event) {
  dataShared.dispatch('activeLoading')

  await SharedService.watchEventById(event?.id)
    .then(res => {
      dataShared.dispatch('setEventToPurchase', event?.id)

      if (res.data.success == false) {
        dataShared.dispatch('desactiveLoading')
        toast('Aviso', 'Adquira acesso ao evento', 'info')
        return router.push(`/purchase/${event?.id}/event`)
      }

      dataShared.dispatch('desactiveLoading')
      dataShared.dispatch('setLiveActive', event)
      router.push(`/live/${event?.id}`)
    }).catch(err => {
      console.log(err)
    })
}

function formatDateFull (dateString) {
  return moment(dateString).format('dddd, D [de] MMMM [de] YYYY')
}

async function getMainEvent () {
  dataShared.dispatch('activeLoading')
  await SharedService.getMainEvent()
    .then((res) => {
      dataShared.dispatch('setMainEvent', res.data.mainEvent)
    }).catch(err => {
      console.log(err)
    })
}

async function getAllEvents () {
  dataShared.dispatch('activeLoading')
  await SharedService.getEvents()
    .then(res => {
      dataShared.dispatch('setAllEvents', res.data)
    }).catch(err => {
      console.log(err)
    })
}

function shuffleArray(array) {
  const a = array.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

onBeforeMount(() => {
  dataShared.dispatch('activeLoading')
  Promise.all([
    getAllEvents(),
    getMainEvent()
  ])
  dataShared.dispatch('desactiveLoading')
})
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0;
}
</style>
